module.exports = __webpack_public_path__ + "static/img/transbank.67ccd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/transbank.png
// module id = fHYk
// module chunks = 1